import { gql } from '@apollo/client';

export const USER_COMPLETE_REGISTRATION_MUTATION = gql`
  mutation UserCompleteRegistration(
    $community: SchoolConfigurationKeyFilter!
    $data: UserCompleteRegistrationInput!
  ) {
    commit: userCompleteRegistration(community: $community, data: $data) {
      accessToken: idToken
      refreshToken
    }
  }
`;

export const USER_SOCIAL_COMPLETE_REGISTRATION_MUTATION = gql`
  mutation UserSocialCompleteRegistration(
    $community: SchoolConfigurationKeyFilter!
    $data: UserSocialCompleteRegistrationInput!
  ) {
    commit: userSocialCompleteRegistration(community: $community, data: $data) {
      success
    }
  }
`;
